import { heroData, amberSectionData, zipengSectionData, danielSectionData, davidSectionData, letaSectionData, gavinSectionData } from 'public/MasterClassData.js';
import wixWindow from 'wix-window';
import { biLoggerFactory } from 'wix-private';

const biLogger = biLoggerFactory('xdc', 110, { msid: '2467fcd2-6eff-4b37-b860-1dc33aa86e0d' });

export async function fireEvent(artistName, className, videoFullLengthSeconds, videoLocation, videoType) {
    const biEventObject = {
        evid: 2002,
        artistName,
        className,
        videoFullLengthSeconds,
        videoLocation,
        videoType,
        topic: 'Design Classes',
        brand_name: 'editor x'
    };
    await biLogger.log(biEventObject);
}


const XBLUE = '#003DFF';
const BLACK = '#000000';

const BIboxesToMasterPage = {
    daniel: {
        box: '#BIboxToDanielPage',
        masterName: 'Daniel Aristizábal',
    },
    amber: {
        box: '#BIboxToAmberPage',
        masterName: 'Amber Vittoria',
    },
    zipeng: {
        box: '#BIboxToZipengPage',
        masterName: 'Zipeng Zhu',
    },
    // david: {
    // 	box: '#BIboxToZipengPage',
    // 	masterName: 'Zipeng Zhu',
    // }
}

$w.onReady(function () {

    // Hero Video Thumbnail
    $w('#box176').onMouseIn(() => {
        $w('#heroVideoPlay').show();
    });
    $w('#box176').onMouseOut(() => {
        $w('#heroVideoPlay').hide();
    });

    activeRedirectToMasterPage();

    // Hero buttons list
    const hero_videos = heroData().then((data) => {
        heroSection(data);
    });

    // video section 01
    const section_1_videos = amberSectionData().then((data) => {
        activeSectionInteraction(data);
    });

    // video section 02
    const section_2_videos = zipengSectionData().then((data) => {
        activeSectionInteraction(data);
    });

    // video section 03
    const section_3_videos = danielSectionData().then((data) => {
        activeSectionInteraction(data);
    });

    // video section 04
    const section_4_videos = davidSectionData().then((data) => {
        activeSectionInteraction(data);
    });

    // video section 05
    const section_5_videos = letaSectionData().then((data) => {
        activeSectionInteraction(data);
    });

    // // video section 06
    const section_6_videos = gavinSectionData().then((data) => {
        activeSectionInteraction(data);
    });

});

// id: '1',
// 			button: '#heroVideoPlay',
// 			video: 'https://video.wixstatic.com/video/0d6674_44c45a3e2ed147c3bd69e1bc7d1eff03/1080p/mp4/file.mp4',
// 			title: 'Meet David Milan.',
// 			description: 'Spanish lettering artist, David Milan, is known for his graffiti-inspired style. His laid back, friendly vibe is reflected in his images that sometimes feature pop culture icons or Disney characters. In his tutorials, David uses sticky position, margins, scroll effects and animation to add new looks to some of his iconic designs.',
// 			masterPage: linkToMasterPage,
// 			artist: artistName,
// 			videoType: videoTypes.intro
function heroSection(videosData) {
    for (let x in videosData) {
        $w(`${videosData[x].button}, ${videosData[x].image}`).onClick(() => {
            const video = videosData[x].video;
            const title = videosData[x].title;
            const description = videosData[x].description;
            const link = videosData[x].masterPage;
            const artist = videosData[x].artist
            fireEvent(videosData[x].artist, title, '', 'hero section', videosData[x].videoType)
            // sendLightBoxBI(video, title, description, link); // Send BI events
            openLightbox(video, title, description, link , artist, videosData[x].videoType);
        });
    }
}

function activeRedirectToMasterPage() {

    for (let i in BIboxesToMasterPage) {
        $w(BIboxesToMasterPage[i].box).onClick(() => {
            // sendRedirectBI(BIboxesToMasterPage[i]);
        });
    }
}

function activeSectionInteraction(videosData) {
    for (let x in videosData) {
        const container = $w(videosData[x].container); // Video container.
        const hoverButton = $w('#' + container.children[1].id); // Button that revealed on hover.
        const button = $w(videosData[x].button); // Video CTA.
        const buttonLine = $w('#' + container.children[3].children[0].id); // CTA border-bottom (this is container not a line).

        $w(videosData[x].button).onClick(() => {
            fireEvent(videosData[x].artist, videosData[x].title, '', 'active section interaction', videosData[x].videoType)
            sendDataToLightbox(videosData[x].video, videosData[x].title, videosData[x].description, videosData[x].masterPage,videosData[x].artist,videosData[x].videoType);
        });
        
        container.children[0].onClick(() => {
            fireEvent(videosData[x].artist, videosData[x].title, '', 'active section interaction', videosData[x].videoType)
            sendDataToLightbox(videosData[x].video, videosData[x].title, videosData[x].description, videosData[x].masterPage,videosData[x].artist,videosData[x].videoType);
        });

        container.onMouseIn(() => {
            hoverButton.show();
            button.style.color = XBLUE;
            buttonLine.style.backgroundColor = XBLUE;
        });

        container.onMouseOut(() => {
            hoverButton.hide();
            button.style.color = BLACK;
            buttonLine.style.backgroundColor = BLACK;
        });

        hoverButton.onClick(() => {
            fireEvent(videosData[x].artist, videosData[x].title, '', 'active section interaction', videosData[x].videoType)
            sendDataToLightbox(videosData[x].video, videosData[x].title, videosData[x].description, videosData[x].masterPage,videosData[x].artist,videosData[x].videoType);
        });
    }
}

function sendDataToLightbox(videoLink, videoTitle, videoDescription, linkToMaster,artist,type) {
    const video = videoLink;
    const title = videoTitle;
    const description = videoDescription;
    const link = linkToMaster;

    // sendLightBoxBI(video, title, description, link); // Send BI events
    openLightbox(video, title, description, link,artist,type);
}

function openLightbox(video, title, description, link,artist,type) {
    wixWindow.openLightbox('MasterClassLightbox', {
        "sendVideo": video,
        "sendTitle": title,
        "sendDescription": description,
        "sendLink": link,
        "artist":artist,
        "videoType":type
    });
}

// BI events //
// function sendLightBoxBI(video, title, description, link) {
// 	console.log(video, title, description, link);
// }

// function sendRedirectBI(clickedButtonInfo) {
// 	console.log(clickedButtonInfo.masterName);
// }

export function davidMilan_click(event) {
    fireEvent('David Milan section - home page', 'David Milan >')
}

export function BIboxToDanielPage_click(event) {
    fireEvent('Daniel Aristizábal section - home page', 'Daniel Aristizábal >')
}

export function BIboxToAmberPage_click(event) {
    fireEvent('Amber Vittoria section - home page', 'Amber Vittoria >')
}

export function BIboxToZipengPage_click(event) {
    fireEvent('Zipeng Zhu section - home page', 'Zipeng Zhu >')
}